(function () {

  function formatMoney(cents) {
    if (!cents && cents !== 0) return '';
    return (cents / 100).toLocaleString('uk-UA', { style: 'currency', currency: 'UAH' });
  }

  window._notifyState = { title: '', price: '', available: true, _originalText: '', _productId: '' };

  var _btnObserver = null;
  var _applyScheduled = false;
  var _scrollY = 0;

  function lockScroll() {
    _scrollY = window.scrollY;
    document.body.style.top = '-' + _scrollY + 'px';
    document.body.classList.add('notify-open');
  }

  function unlockScroll() {
    document.body.classList.remove('notify-open');
    document.body.style.top = '';
    window.scrollTo(0, _scrollY);
  }

  function getFreshTitle() {
    var btn = document.querySelector('[ref="addToCartButton"]');
    if (btn && btn.dataset.productTitle) return btn.dataset.productTitle;
    var atc = document.querySelector('add-to-cart-component');
    if (atc && atc.dataset.productTitle) return atc.dataset.productTitle;
    return window._notifyState.title || '';
  }

  function getFreshPrice() {
    var btn = document.querySelector('[ref="addToCartButton"]');
    if (btn && btn.dataset.productPrice) return btn.dataset.productPrice;
    var atc = document.querySelector('add-to-cart-component');
    if (atc && atc.dataset.productPrice) return atc.dataset.productPrice;
    return window._notifyState.price || '';
  }

  function fillDrawer(title, price) {
    var t = document.getElementById('NotifyProductTitle');
    var p = document.getElementById('NotifyProductPrice');
    var i = document.getElementById('NotifyProductInput');
    if (t) t.textContent = title;
    if (p) p.textContent = price;
    if (i) i.value = title;
  }

  window.openNotifyDrawer = function (title, price) {
    var t = getFreshTitle() || title || '';
    var p = getFreshPrice() || price || '';
    fillDrawer(t, p);
    window._notifyState.title = t;
    window._notifyState.price = p;
    var drawer = document.getElementById('NotifyDrawer');
    var overlay = document.getElementById('NotifyOverlay');
    if (!drawer || !overlay) return;
    drawer.setAttribute('aria-hidden', 'false');
    drawer.classList.add('is-active');
    overlay.classList.add('is-active');
    lockScroll();
    if (window._notifyState._productId) {
      loadRecommendations(window._notifyState._productId);
    }
  };

  function closeDrawer() {
    var drawer = document.getElementById('NotifyDrawer');
    var overlay = document.getElementById('NotifyOverlay');
    if (!drawer || !overlay) return;
    drawer.setAttribute('aria-hidden', 'true');
    drawer.classList.remove('is-active');
    overlay.classList.remove('is-active');
    unlockScroll();
  }

  document.addEventListener('click', function(e) {
    if (e.target.closest('.js-notify-close')) closeDrawer();
  });

  function loadRecommendations(productId) {
    var container = document.getElementById('NotifyRecommendationsContainer');
    var prevBtn = document.getElementById('NotifyRecPrev');
    var nextBtn = document.getElementById('NotifyRecNext');
    if (!container || !productId) return;
    container.innerHTML = '';
    if (prevBtn) prevBtn.classList.add('is-hidden');
    if (nextBtn) nextBtn.classList.add('is-hidden');
    fetch('/recommendations/products.json?product_id=' + productId + '&limit=6&intent=related')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var products = data.products;
        if (!products || !products.length) return;
        container.innerHTML = products.map(function(p) {
          var rawImg = (typeof p.featured_image === 'string' ? p.featured_image : '')
            || (p.images && p.images[0] ? p.images[0] : '')
            || (p.media && p.media[0] ? p.media[0].src : '');
          var img = rawImg ? ('https:' + rawImg.replace(/^https?:/, '')) : '';
          img = img.replace(/(\.(png|jpg|jpeg|gif|webp))(\?|$)/i, '_300x$1$3');
          var price = p.variants && p.variants[0] ? p.variants[0].price : 0;
          var isNew = p.tags && p.tags.indexOf('new') !== -1;
          var priceFormatted = (price / 100).toLocaleString('uk-UA') + '\u00a0\u20b4';
          return '<a href="' + p.url + '" class="notify-rec__card">'
            + '<div class="notify-rec__image">'
            + (img ? '<img src="' + img + '" alt="' + p.title + '" loading="lazy">' : '<div style="width:100%;height:100%;background:#f0f0f0"></div>')
            + (isNew ? '<span class="notify-rec__badge">NEW</span>' : '')
            + '</div>'
            + '<div class="notify-rec__info">'
            + '<p class="notify-rec__name">' + p.title + '</p>'
            + '<p class="notify-rec__price">' + priceFormatted + '</p>'
            + '</div>'
            + '</a>';
        }).join('');
        setTimeout(function() {
          var canScroll = container.scrollWidth > container.clientWidth + 10;
          if (prevBtn) prevBtn.classList.add('is-hidden');
          if (nextBtn) nextBtn.classList.toggle('is-hidden', !canScroll);
        }, 100);
        container.addEventListener('scroll', function() {
          if (!prevBtn || !nextBtn) return;
          prevBtn.classList.toggle('is-hidden', container.scrollLeft < 10);
          nextBtn.classList.toggle('is-hidden', container.scrollLeft + container.clientWidth >= container.scrollWidth - 10);
        });
      })
      .catch(function() { container.innerHTML = ''; });
  }

  document.addEventListener('click', function(e) {
    if (e.target.closest('#NotifyRecNext')) {
      var track = document.getElementById('NotifyRecommendationsContainer');
      if (track) { var card = track.querySelector('.notify-rec__card'); track.scrollBy({ left: (card ? card.offsetWidth + 10 : 200) * 2, behavior: 'smooth' }); }
    }
    if (e.target.closest('#NotifyRecPrev')) {
      var track = document.getElementById('NotifyRecommendationsContainer');
      if (track) { var card = track.querySelector('.notify-rec__card'); track.scrollBy({ left: -(card ? card.offsetWidth + 10 : 200) * 2, behavior: 'smooth' }); }
    }
  });

  function initOriginalText() {
    var btn = document.querySelector('[ref="addToCartButton"]');
    if (!btn) return;
    var textEl = btn.querySelector('.actual-btn-text');
    if (textEl && !window._notifyState._originalText) {
      var t = textEl.textContent.trim();
      if (t && t !== 'Повідомити про наявність') window._notifyState._originalText = t;
    }
  }

  function isUnselectedState(btn) {
    return btn && btn.classList.contains('is-unselected-state');
  }

  function setNotifyHandler(btn) {
    if (btn._notifyHandler) { btn.removeEventListener('click', btn._notifyHandler); btn._notifyHandler = null; }
    btn.removeAttribute('onclick');
    btn._notifyHandler = function(e) {
      e.preventDefault();
      e.stopPropagation();
      window.openNotifyDrawer(btn.dataset.productTitle, btn.dataset.productPrice);
    };
    btn.addEventListener('click', btn._notifyHandler);
  }

  function setButtonUnavailable(btn) {
    if (!btn || isUnselectedState(btn)) return;
    btn.setAttribute('type', 'button');
    btn.removeAttribute('name');
    btn.removeAttribute('disabled');
    btn.disabled = false;
    setNotifyHandler(btn);
    var textEl = btn.querySelector('.actual-btn-text');
    if (textEl && textEl.textContent.trim() !== 'Повідомити про наявність') textEl.textContent = 'Повідомити про наявність';
  }

  function setButtonAvailable(btn) {
    if (!btn || isUnselectedState(btn)) return;
    btn.setAttribute('type', 'submit');
    btn.setAttribute('name', 'add');
    if (btn._notifyHandler) { btn.removeEventListener('click', btn._notifyHandler); btn._notifyHandler = null; }
    btn.removeAttribute('onclick');
    var textEl = btn.querySelector('.actual-btn-text');
    var expected = window._notifyState._originalText || 'Додати в кошик';
    if (textEl && textEl.textContent.trim() !== expected) textEl.textContent = expected;
  }

  function applyButtonState(available, title, price) {
    var btn = document.querySelector('[ref="addToCartButton"]');
    if (!btn || isUnselectedState(btn) || btn.disabled) return;

    window._notifyState.title = title;
    window._notifyState.price = price;
    window._notifyState.available = available;

    if (_btnObserver) { _btnObserver.disconnect(); _btnObserver = null; }

    if (!available) setButtonUnavailable(btn);
    else setButtonAvailable(btn);

    _btnObserver = new MutationObserver(function(muts) {
      if (_applyScheduled) return;
      var currentBtn = document.querySelector('[ref="addToCartButton"]');
      if (!currentBtn || isUnselectedState(currentBtn) || currentBtn.disabled) return;
      var needsCorrection = false;
      muts.forEach(function(m) {
        if (m.type === 'characterData') {
          var currentText = m.target.textContent.trim();
          if (!window._notifyState.available && currentText !== 'Повідомити про наявність') needsCorrection = true;
          if (window._notifyState.available && currentText === 'Повідомити про наявність') needsCorrection = true;
        }
      });
      if (needsCorrection) {
        _applyScheduled = true;
        requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            var b = document.querySelector('[ref="addToCartButton"]');
            if (b && !isUnselectedState(b) && !b.disabled) {
              if (!window._notifyState.available) setButtonUnavailable(b);
              else setButtonAvailable(b);
            }
            _applyScheduled = false;
          });
        });
      }
    });
    _btnObserver.observe(btn, { childList: true, subtree: true, characterData: true });

    var drawer = document.getElementById('NotifyDrawer');
    if (drawer && drawer.classList.contains('is-active')) fillDrawer(title, price);
  }

  function initFromVariantId() {
    var urlParams = new URLSearchParams(window.location.search);
    var variantId = urlParams.get('variant');
    var atc = document.querySelector('add-to-cart-component');
    var title = atc ? (atc.dataset.productTitle || '') : '';
    var price = atc ? (atc.dataset.productPrice || '') : '';
    var picker = document.querySelector('[ref="mainVariantPicker"]');
    if (picker && picker.dataset.productId) window._notifyState._productId = picker.dataset.productId;
    var btn = document.querySelector('[ref="addToCartButton"]');
    if (btn && isUnselectedState(btn)) return;
    if (variantId) {
      fetch('/variants/' + variantId + '.js')
        .then(function(r) { return r.json(); })
        .then(function(variant) {
          if (variant.product_id) window._notifyState._productId = String(variant.product_id);
          applyButtonState(variant.available, title, price);
        })
        .catch(function() {});
    } else {
      if (btn) { var isAvailable = btn.getAttribute('type') === 'submit'; applyButtonState(isAvailable, title, price); }
    }
  }

  document.addEventListener('variant:update', function(e) {
    var detail = e.detail;
    if (!detail || !detail.resource) return;
    var res = detail.resource;
    var available = typeof res.available !== 'undefined' ? res.available : true;
    var price = res.price ? formatMoney(res.price) : '';
    var picker = document.querySelector('[ref="mainVariantPicker"]');
    if (picker && picker.dataset.productId) window._notifyState._productId = picker.dataset.productId;
    var btn = document.querySelector('[ref="addToCartButton"]');
    if (btn && btn.classList.contains('is-unselected-state')) {
      btn.classList.remove('is-unselected-state');
      if (btn._notifyHandler) { btn.removeEventListener('click', btn._notifyHandler); btn._notifyHandler = null; }
      btn.removeAttribute('onclick');
    }
    [150, 400, 800].forEach(function(delay) {
      setTimeout(function() {
        var b = document.querySelector('[ref="addToCartButton"]');
        if (!b || isUnselectedState(b) || b.disabled) return;
        var freshTitle = b.dataset.productTitle || '';
        var atc = document.querySelector('add-to-cart-component');
        var finalPrice = price || (atc ? atc.dataset.productPrice || '' : '');
        initOriginalText();
        applyButtonState(available, freshTitle, finalPrice);
      }, delay);
    });
  });

  var atcEl = document.querySelector('add-to-cart-component');
  if (atcEl) {
    new MutationObserver(function() {
      if (!window._notifyState.available) {
        var btn = document.querySelector('[ref="addToCartButton"]');
        window._notifyState.title = (btn && btn.dataset.productTitle) || atcEl.dataset.productTitle || '';
        window._notifyState.price = (btn && btn.dataset.productPrice) || atcEl.dataset.productPrice || '';
      }
    }).observe(atcEl, { attributes: true, attributeFilter: ['data-product-title', 'data-product-price'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { initOriginalText(); setTimeout(initFromVariantId, 500); });
  } else {
    initOriginalText();
    setTimeout(initFromVariantId, 500);
  }

})();